import laundriesService from "api/laundriesService";
import { useMutation } from "react-query";

import { IAddLaundryHolidayBody } from "types/laundry";

const useAddLaundryHolidayMutation = () => {
  return useMutation(async (data: IAddLaundryHolidayBody) => {
    try {
      const res = await laundriesService.addLaundryHoliday(data)

      return res.data
    } catch (err: any) {
      return {
        err: err.message,
        errStatus: err.response.status,
      }
    }
  }) 
}

export default useAddLaundryHolidayMutation